<template>
  <el-dialog :visible="visible" class="responsive product-history-modal" width="900px" :close-on-click-modal="false"
    @close="handleClose">
    <span slot="title" class="modal-title-with-icon">
      <i :class="['fas', iconClass, 'modal-title-icon']"></i>
      {{ modalTitle }}
    </span>

    <div v-loading="loading" class="history-content">
      <div v-if="!loading && (!data || data.length === 0)" class="empty-state">
        Chưa có lịch sử
      </div>

      <div v-else class="history-table-wrapper">
        <table class="table table-bordered table-vertical-center history-table mb-0">
          <thead class="history-thead bg-light">
            <tr>
              <th v-for="col in columns" :key="col.key" scope="col" class="text-left align-middle font-weight-bold">
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data" :key="index">
              <td v-for="col in columns" :key="col.key" class="text-left align-middle">
                <template v-if="col.key === 'created_at'">
                  {{ formatDate(row[col.key]) }}
                </template>
                <template v-else-if="col.key === 'price'">
                  {{ formatCurrency(row[col.key]) }}
                </template>
                <template v-else-if="col.key === 'quantity_before'">
                  {{ getQuantityBefore(row) }}
                </template>
                <template v-else>
                  {{ row[col.key] ?? "-" }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <footer class="d-flex justify-content-end pt-4">
      <button type="button" class="btn btn-secondary font-weight-bold" @click="handleClose">Đóng</button>
    </footer>
  </el-dialog>
</template>

<script>
export default {
  name: "ProductHistoryModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
      validator: (v) => ["price", "stock"].includes(v),
    },
    product: {
      type: Object,
      default: null,
    },
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalTitle() {
      const name = this.product?.name || "Sản phẩm";
      if (this.type === "price") {
        return `Lịch sử giá sản phẩm ${name}`;
      }
      return `Lịch sử xuất nhập kho ${name}`;
    },
    iconClass() {
      return this.type === "price" ? "fa-chart-line" : "fa-wave-square";
    },
    columns() {
      if (this.type === "price") {
        return [
          { key: "created_at", label: "Thời gian" },
          { key: "price", label: "Giá" },
        ];
      }
      return [
        { key: "created_at", label: "Thời gian" },
        { key: "type_text", label: "Loại" },
        { key: "price", label: "Giá tại thời điểm" },
        { key: "quantity_before", label: "Số lượng trước nhập" },
        { key: "stock_quantity", label: "Tồn kho" },
        { key: "added_quantity", label: "Số lượng thay đổi" },
        { key: "branch_name", label: "Chi nhánh" },
        { key: "note", label: "Ghi chú" },
      ];
    },
  },
  methods: {
    formatDate(val) {
      if (!val) return "-";
      const d = new Date(val);
      if (Number.isNaN(d.getTime())) return val;
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    formatCurrency(val) {
      if (val == null || val === "") return "-";
      const numericValue = Number(val);
      return `${new Intl.NumberFormat("vi-VN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number.isNaN(numericValue) ? 0 : numericValue)} VNĐ`;
    },
    getQuantityBefore(row) {
      return Number(row.stock_quantity || 0) - Number(row.added_quantity || 0);
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.product-history-modal>>>.el-dialog__header {
  padding-bottom: 0.5rem;
}

.modal-title-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-title-icon {
  color: #3699ff;
  font-size: 1.125rem;
}

.history-content {
  min-height: 120px;
}

.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
  font-size: 0.9375rem;
}

.history-table-wrapper {
  border: 1px solid #ebedf3;
  border-radius: 0.25rem;
  max-height: 400px;
  overflow: auto;
}

.history-table {
  min-width: 100%;
}

.history-thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.history-table th,
.history-table td {
  vertical-align: middle;
  padding: 0.6rem 0.75rem;
  white-space: nowrap;
}
</style>
